import React from 'react';
import PropTypes from 'prop-types';

import svgElementsStyles from '../styles/GraphSVGElements';

import {cutString} from '../util';
import config from '../config';

const labelInnerBoxWidth = config.sizes.nodeWidth - config.sizes.nodeInnerPadding * 2;
const labelInnerBoxHeight = config.sizes.edgeLabelInnerBoxHeight;

class EdgeButton extends React.PureComponent {
    render() {
        const {
            isHighlighted, y, isConnected, text, id, isFolded,
        } = this.props;


        const stroke = isHighlighted ? '#4060b4' : '#8b8b91';
        const strokeWidth = isHighlighted ? config.sizes.highlightStrokeWidth : 1;
        const addNodeButtonVisibility = isHighlighted && (!isConnected) ? 'visible' : 'hidden';

        const transform = `translate(0, ${y})`;
        const addNodeTransformX = config.sizes.nodeWidth - 2 * config.sizes.nodeInnerPadding - config.sizes.addNodeIconWidth / 2;
        const addVertexTransformY = (config.sizes.edgeLabelInnerBoxHeight - config.sizes.addNodeIconHeight) / 2;
        const addVertexTransform = `translate(${addNodeTransformX},${addVertexTransformY})`;

        const cellStyles = isFolded ? svgElementsStyles.edgeButtonCellFolded : svgElementsStyles.edgeButtonCell;

        return (
            <g transform={transform} className="edge-label">
                <rect {...cellStyles} cursor="pointer" stroke={stroke} strokeWidth={strokeWidth}
                      width={labelInnerBoxWidth} height={labelInnerBoxHeight}
                      fill={text.includes("||") ? '#95abea' : 'rgba(230,250,238,0.99)'}
                />
                <text data-edgeid={id} className="svg-text" {...svgElementsStyles.edgeButtonText} cursor="pointer"
                      pointerEvents="none">
                    {cutString(text.includes("||") ? text.split("||")[0] : text, 15)}
                </text>
                <g className="controller-hide" data-edgeid={id} visibility={addNodeButtonVisibility} cursor="pointer"
                   transform={addVertexTransform}>
                    <path
                        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
                        fill="#2A60E4"/>
                    <path
                        d="M0.5 10C0.224 10 0 9.776 0 9.5V0.5C0 0.224 0.224 0 0.5 0C0.776 0 1 0.224 1 0.5V9.5C1 9.776 0.776 10 0.5 10Z"
                        transform="translate(8.5 4)" fill="white"/>
                    <path
                        d="M10 0.5C10 0.776 9.776 1 9.5 1H0.5C0.224 1 0 0.776 0 0.5C0 0.224 0.224 0 0.5 0H9.5C9.776 0 10 0.224 10 0.5Z"
                        transform="translate(4 8.5)" fill="white"/>
                </g>
            </g>
        );
    }
}

EdgeButton.propTypes = {
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    y: PropTypes.number.isRequired,
    isConnected: PropTypes.bool.isRequired,
    isFolded: PropTypes.bool.isRequired,
    isHighlighted: PropTypes.bool.isRequired,
};

export default EdgeButton;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/EdgeButton.jsx